"use client";
import React from "react";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

export type WcTooltip = TooltipProps & {
  inputWidth?: string | number;
};

export const WcTooltip = ({ ...props }: WcTooltip) => <Tooltip {...props}>{props.children}</Tooltip>;

export default WcTooltip;

//@ts-ignore
export const WcCustomToolTip :  ReturnType<typeof WcTooltip> =  styled(({ className, inputWidth, ...props }: WcTooltip) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, inputWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: inputWidth || 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));
